import React from 'react';

import './SaleResultsDetailPage.scss';

const GrandTotalsTable = ({ grandTotals, currencySymbol }) => (
  <table className="grand-totals-table">
    <tbody>
      <tr className="font-weight-bold">
        <td className="label-cell">
          <h2>
            Grand Totals
          </h2>
        </td>
        <td>
          Lots
        </td>
        <td>
          Hammer
        </td>
        <td>
          BP
        </td>
        <td>
          Live Fee
        </td>
        <td>
          Payable
        </td>
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td className="numeric-cell">{grandTotals?.lotCount}</td>
        <td className="numeric-cell"> {currencySymbol}{grandTotals?.hammer}</td>
        <td className="numeric-cell"> {currencySymbol}{grandTotals?.buyPrem}</td>
        <td className="numeric-cell"> {currencySymbol}{grandTotals?.liveFee}</td>
        <td className="numeric-cell"> {currencySymbol}{grandTotals?.payable}</td>
      </tr>
    </tbody>
  </table>
);

export default GrandTotalsTable;
